import { Text, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';

const explanationStyles = css`
  color: #737373;
`;

const MandatoryInformationMessage = () => {
  const { t } = useTranslation();
  return (
    <Text
      as="p"
      className={explanationStyles}
      data-testid="validationMessages-mandatoryFields-message"
      variant={textVariants._12}
    >
      {t('ValidationMessages.MandatoryFields')}
    </Text>
  );
};

export default MandatoryInformationMessage;
